module.exports = __webpack_public_path__ + "img/bg-2.b55ba2d3.png";